module.exports = __webpack_public_path__ + "images/illustrations/reach-icon-heart-b665b11640dc6d2815ec587c30af80e1.svg";